import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import { plainTextStyle } from '@westwing/ui-kit/typography';
import { inputStyles, textStyles } from '../GlobalStyles/Normalizer';
import { useShowAppBanner } from './AppBanner/useAppBanner';
import { HeaderModeType, useLayoutByPage } from 'Client/hooks/useLayoutByPage';

const GlobalStickyHeaderStyles = createGlobalStyle`
    #wwOneHeader {
        z-index: ${({ theme }) => theme.zindexOneHeader};
        ${forDesktop`
            position: unset;
        `}

        /* Header should always be sticky on Alice pages on up to desktop breakpoint */
        body:not(.bella) & {
            position: sticky;

            ${forDesktop`
                position: unset;
            `}
        }
    }

    .wwOneHeader__Shadow--outer {
        display: block;
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), transparent);
        height: 2px;
        left: 0;
        position: sticky;
        top: ${({ theme }) => `${theme.oneHeaderModuleHeight}px`};
        z-index: ${({ theme }) => theme.zindexOneHeaderShadow};
        ${forDesktop`
            display: none;
        `}
    }

    body:not(.bella) .wwOneHeader__Shadow--inner {
        display: none;
    }

    .wwOneHeader__NavBar--outer,
    .wwOneHeader__NavBar--inner {
        margin-top: -2px; /* to cover the OneHeaderShadow */
        position: relative;
        z-index: ${({ theme }) => theme.zindexOneHeaderNavBar};
    }

    body:not(.bella) .wwOneHeader__NavBar--inner {
        position: unset;
        margin-top: 0px;
    }

    /* using attr selector because it has less specificity then #wwOneHeader  */
    [id='wwOneHeader'],
    [id='wwOneHeader__NavBar'],
    [id='wwOneHeader__BannerBar'] {
        ${textStyles}
        ${plainTextStyle}
        ${inputStyles}
    }

    .wwOneHeader_main {
        top: ${({ theme }) => `-${theme.newHeaderTabsHeight}px`};
    }
`;

const StyledDiv = styled.div<{ smartBanner: boolean; isSticky: boolean }>`
    position: ${({ isSticky }) => (isSticky ? 'sticky' : 'static')};
    top: ${({ theme, smartBanner }) =>
        smartBanner ? `${theme.smartBannerHeight - theme.newHeaderTabsHeight}px` : `-${theme.newHeaderTabsHeight}px`};
`;

const OneHeaderContainer: React.FC<{ className: string; detachedHeaderMode: boolean }> = ({
    children,
    className,
    detachedHeaderMode,
}) => {
    const shouldShow = useShowAppBanner('smart');
    const { headerMode } = useLayoutByPage();

    return (
        <>
            <GlobalStickyHeaderStyles />
            <StyledDiv
                id={detachedHeaderMode ? '' : 'wwOneHeader'}
                isSticky={headerMode === HeaderModeType.DEFAULT}
                className={className}
                smartBanner={shouldShow}
            >
                {children}
            </StyledDiv>
        </>
    );
};

export default OneHeaderContainer;
